import { render, staticRenderFns } from "./FreeDiamondModal.vue?vue&type=template&id=3580cb2a&scoped=true&"
import script from "./FreeDiamondModal.vue?vue&type=script&lang=js&"
export * from "./FreeDiamondModal.vue?vue&type=script&lang=js&"
import style0 from "./FreeDiamondModal.vue?vue&type=style&index=0&id=3580cb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3580cb2a",
  null
  
)

export default component.exports